import { QueryClient } from "@tanstack/react-query";

/**
 * Global QueryClient configuration for TanStack Query
 *
 * Default settings:
 * - Queries are cached for 5 minutes
 * - Stale data is refetched in the background
 * - Failed queries retry 1 time before giving up
 * - Tab visibility detection enabled (pauses queries when tab is inactive)
 */
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			// How long before a query is considered "stale" and needs refetching
			staleTime: 1000 * 60 * 5, // 5 minutes

			// How long inactive query results stay in cache
			gcTime: 1000 * 60 * 10, // 10 minutes (formerly "cacheTime")

			// Automatically refetch on window focus
			refetchOnWindowFocus: true,

			// Automatically refetch when network reconnects
			refetchOnReconnect: true,

			// Don't refetch on mount if data is still fresh
			refetchOnMount: true,

			// Retry failed requests once before giving up
			retry: 1,

			// Exponential backoff for retries
			retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
		},
		mutations: {
			// Retry failed mutations once
			retry: 1,
		},
	},
});
